import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsGathers(
  {
    page, size, direction, sort,
  }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-gather`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGather(gatherId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-gather/${gatherId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGather(
  {
    name,
    coverPath,
    isPush,
    isRecommended,
    linkType,
    seriesId,
    categoryId,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-gather`,
    method: 'post',
    data: {
      name,
      coverPath,
      isPush,
      isRecommended,
      linkType,
      seriesId,
      categoryId,
    },
  });
}

/**
 * 更新
 * @param goodsCategoryId
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGather(gatherId, {
  name,
  coverPath,
  isPush,
  isRecommended,
  linkType,
  seriesId,
  categoryId,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-gather/${gatherId}`,
    method: 'patch',
    data: {
      name,
      coverPath,
      isPush,
      isRecommended,
      linkType,
      seriesId,
      categoryId,
    },
  });
}

/**
 * 删除
 * @param goodsCategoryId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGather(gatherId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-gather/${gatherId}`,
    method: 'delete',
  });
}

export function _updateGoodsSort({ idStr, sortStr, oldIndex, newIndex
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website/gather/update`,
    method: 'post',
    params: {
      idStr: idStr,
      sortStr: sortStr,
      oldIndex: oldIndex,
      newIndex: newIndex
    }
  });
}

export default {};
